import {Component, NgModule} from '@angular/core';
import { FooterModule } from '../footer/footer';
import { HeaderModule } from '../header/header';

@Component({
  selector: 'app-features',
  templateUrl: './features.html',
  styleUrls: ['./features.scss']
})
export class Features {
    
}


@NgModule({
  imports: [FooterModule,HeaderModule],
  exports: [Features],
  declarations: [Features],
})
export class FeaturesModule {}